import { useCallback, useEffect, useRef, useState } from "react";

const useTimer = (duration = 1 * 60 * 1000) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);
  const STORAGE_KEY = "timer_start_time";

  const clearTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const checkTimer = useCallback(() => {
    const startTime = localStorage.getItem(STORAGE_KEY);
    if (!startTime) return;

    const elapsed = Date.now() - parseInt(startTime);

    if (elapsed >= duration) {
      setIsOpen(true);
      localStorage.removeItem(STORAGE_KEY);
      clearTimer();
      return;
    }

    // Планируем следующую проверку через 10 секунд
    timeoutRef.current = setTimeout(checkTimer, 10000);
  }, [duration, clearTimer]);

  const startTimer = useCallback(() => {
    clearTimer();

    const startTime = Date.now();
    localStorage.setItem(STORAGE_KEY, startTime.toString());

    // Начать проверку через 10 секунд
    timeoutRef.current = setTimeout(checkTimer, 10000);
  }, [checkTimer, clearTimer]);

  const stopTimer = useCallback(() => {
    clearTimer();
    localStorage.removeItem(STORAGE_KEY);
    setIsOpen(false);
  }, [clearTimer]);

  const restartTimer = useCallback(() => {
    stopTimer();
    setTimeout(startTimer, 0);
  }, [startTimer, stopTimer]);

  // Автоматически возобновить таймер при монтировании, если он был запущен
  const existingStartTime = localStorage.getItem(STORAGE_KEY);
  useEffect(() => {
    if (existingStartTime) {
      // Продолжить существующий таймер
      timeoutRef.current = setTimeout(checkTimer, 1000); // Check immediately, then every 10s
    } else {
      // Начать новый таймер
      startTimer();
    }

    // Cleanup on unmount
    return () => clearTimer();
  }, [startTimer, checkTimer, clearTimer]);

  return {
    isOpen,
    startTimer,
    stopTimer,
    restartTimer,
  };
};

export default useTimer;
